import en from './en.json';

/**
 * All UI strings go through t(). English only for the POC. To add a language,
 * add a catalog file with the same keys and register it in `catalogs`.
 */
export type MessageKey = keyof typeof en;
type Params = Record<string, string | number>;

const catalogs = { en } as const;
export type Locale = keyof typeof catalogs;

let locale: Locale = 'en';

export function setLocale(next: Locale): void {
  locale = next;
  document.documentElement.lang = next;
}

export function t(key: MessageKey, params?: Params): string {
  const template: string = catalogs[locale][key] ?? key;
  if (!params) return template;
  return template.replace(/\{(\w+)\}/g, (_, name: string) => String(params[name] ?? `{${name}}`));
}
